<template>
    <div class="personal">
        <ul>
            <li class="th">基本信息</li>
            <li @click="menuStatus.AccountSetting = true">
                <span>账号信息</span>
                <iconpark-icon name="page-next" />
            </li>
            <li @click="menuStatus.PasswordSetting = true">
                <span>修改密码</span>
                <iconpark-icon name="page-next" />
            </li>
            <li @click="menuStatus.MobileSetting = true">
                <span>修改手机号</span>
                <iconpark-icon name="page-next" />
            </li>
        </ul>
        <ul>
            <li class="th">实名认证</li>
            <li v-if="userInformation.authStatus != 4" @click="router.push('/workbench/personal/auth')">
                <span>实名认证</span>
                <!-- <RouterLink to="/workbench/personal/auth">实名认证</RouterLink> -->
                <iconpark-icon name="page-next" />
            </li>
            <li v-else @click="router.push('/workbench/personal/auth')">
                <!-- <RouterLink to="/workbench/personal/auth">已认证 {{ userInformation.txIdz }}</RouterLink> -->
                 <span>已认证 {{ userInformation.txIdz }}</span>
                <iconpark-icon name="page-next" />
            </li>
        </ul>
        <ul>
            <li class="th">第三方绑定</li>
            <li @click="toBindThird(WeChat)">
                <span>个人微信</span>
                <span>
                    <i>{{ bindState.wechat }}</i>
                    <iconpark-icon name="page-next" />
                </span>
            </li>
            <li class="disbale">
                <span>企业微信</span>
                <span>
                    <i>未绑定</i>
                    <iconpark-icon name="page-next" />
                </span>
            </li>
            <li @click="toBindThird(AliPay)">
                <span>支付宝</span>
                <span>
                    <i>{{ bindState.alipay }}</i>
                    <iconpark-icon name="page-next" />
                </span>
            </li>
            <li class="disbale">
                <span>微博</span>
                <span>
                    <i>未绑定</i>
                    <iconpark-icon name="page-next" />
                </span>
            </li>
            <li v-if="userInformation.email" @click="menuStatus.EmailSetting = true">
                <span>邮箱</span>
                <span>
                    <i>{{ userInformation.email }}</i>
                    <iconpark-icon name="page-next" />
                </span>
            </li>
            <li @click="menuStatus.EmailSetting = true" v-else>
                <span>邮箱</span>
                <span>
                    <i>未绑定</i>
                    <iconpark-icon name="page-next" />
                </span>
            </li>
        </ul>
    </div>

    <van-dialog v-model:show="menuStatus.AccountSetting" title="账号信息" :showConfirmButton="false" :closeOnClickOverlay="true">
        <AccountSetting @close="menuStatus.AccountSetting = false" />
    </van-dialog>
    <van-dialog v-model:show="menuStatus.PasswordSetting" title="修改密码" :showConfirmButton="false" :closeOnClickOverlay="true">
        <PasswordSetting @close="menuStatus.PasswordSetting = false" />
    </van-dialog>
    <van-dialog v-model:show="menuStatus.MobileSetting" title="修改手机号" :showConfirmButton="false" :closeOnClickOverlay="true">
        <MobileSetting @close="menuStatus.MobileSetting = false" />
    </van-dialog>
</template>

<script setup>

import { computed, ref, onMounted, reactive } from 'vue'
import { RouterLink, useRoute, useRouter } from 'vue-router';
import { useStore } from 'vuex'
import { http } from '@/request/http'
import AccountSetting from './AccountSetting.vue'
import MobileSetting from './MobileSetting.vue'
import EmailSetting from './EmailSetting.vue'
import PasswordSetting from './PasswordSetting.vue'


const AliPay = 50
const WeChat = 31
const router = useRouter(), route = useRoute()
const store = useStore()
const userInformation = computed(() => store.state.login.userInfo)
const menuStatus = reactive({
    AccountSetting: false,
    EmailSetting: false,
    PasswordSetting: false,
    MobileSetting: false
})
const bindState = reactive({
    wechat: null,
    alipay: null
})
const toBindThird = type => {
    if (type == WeChat && bindState.wechat) return
    if (type == AliPay && bindState.alipay) return
    http.get('/app-api/member/auth/social-auth-redirect', {
        params: {
            type,  //微信10  支付宝50
            redirectUri: 'http://www.xinghancloud.com/workbench/personal/account'
        }
    }).then(res => {
        location.href = res
    })
}

onMounted(() => {
    queryBindState()
    checkBind()
    if (route.query.tab) {
        switch (route.query.tab) {
            case 'password':
                menuStatus.PasswordSetting = true
                break;
            case 'phone':
                menuStatus.MobileSetting = true
                break;
            case 'account':
                menuStatus.AccountSetting = true
                break;
        }
    }

})

function queryBindState() {
    http.get('/app-api/member/social-user/list').then(res => {
        res.map(item => {
            if (item.type == WeChat) bindState.wechat = item.nickname
            if (item.type == AliPay) bindState.alipay = item.nickname
        })
    })
}

function checkBind() {
    const { source, auth_code, code, state } = route.query
    if (state) {
        const params = {
            state: state
        }
        //微信
        if (code) {
            params.code = code
            params.type = WeChat
        }
        //支付宝
        if (auth_code) {
            params.code = auth_code
            params.type = AliPay
        }
        http.post('/app-api/member/social-user/bind', params).then(res => {
            queryBindState()
        })
    }
}


</script>

<style lang="scss" scoped>
.personal{
    padding: 20rem; background-color: #F7F7F9; min-height: 100vh;
    ul{
        border-radius: 10rem; overflow: hidden; margin: 20rem 0;  background-color: #fff; 
        li{
            height: 50rem; display: flex; align-items: center; justify-content: space-between;  padding: 0 10rem;
             font-size: 14rem; color: #333333; border-bottom: 1px solid #F5F6FA;
        }
        li:last-child{
            border-bottom: none;
        }
        li:first-child{
            background-color: #FCFCFC; font-weight: bold;
        }

    }
}
</style>
